var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.condition.signed),callback:function ($$v) {_vm.$set(_vm.condition, "signed", $$v)},expression:"condition.signed"}},[_c('v-radio',{attrs:{"label":"Yes","value":true}}),_c('v-radio',{attrs:{"label":"No","value":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }